/**
 * Check if a given object implements the UpdateLearningDomainImageSetRequest interface.
 */
export function instanceOfUpdateLearningDomainImageSetRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "imageSetId" in value;
    return isInstance;
}
export function UpdateLearningDomainImageSetRequestFromJSON(json) {
    return UpdateLearningDomainImageSetRequestFromJSONTyped(json, false);
}
export function UpdateLearningDomainImageSetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'imageSetId': json['imageSetId'],
    };
}
export function UpdateLearningDomainImageSetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'imageSetId': value.imageSetId,
    };
}
